export default {
      id: "phone-up-alt-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#phone-up-alt-usage",
      toString: function () {
        return this.url;
      }
    }